module.exports = __webpack_public_path__ + "static/img/ISO9001.355a426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISO9001.png
// module id = TSLG
// module chunks = 1